import BOSFilterMultiselect from 'Components/Generic/BOSMultiselect/BOSFilterMultiselect';
import { useVendorContext } from 'Data/context/Vendors';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const VendorMultiselect = ({
  onSelectedVendorsUpdate,
  defaultSelectedItems,
  labelText = 'Vendor',
  maxWidth = 240,
  autofocus = true,
  showDeactivated = true,
  ...props
}) => {
  const [selectedVendors, setSelectedVendors] = useState(
    defaultSelectedItems || [],
  );
  const { getFilteredList } = useVendorContext();
  let filteredList = getFilteredList({ showDeactivated });

  useEffect(() => {
    onSelectedVendorsUpdate && onSelectedVendorsUpdate(selectedVendors);
  }, [selectedVendors]);

  const onSelectionChange = (vendors) => {
    setSelectedVendors(vendors);
  };

  return (
    <BOSFilterMultiselect
      labelText={labelText}
      labelField={'displayName'}
      listData={filteredList}
      onSelectionUpdate={onSelectionChange}
      placeholder='Select Vendor(s)...'
      defaultSelectedItems={defaultSelectedItems}
      maxWidth={maxWidth}
      autofocus={autofocus}
      {...props}
    />
  );
};

VendorMultiselect.propTypes = {
  onSelectedVendorsUpdate: PropTypes.func,
  defaultSelectedItems: PropTypes.array,
  labelText: PropTypes.string,
  maxWidth: PropTypes.number,
  autofocus: PropTypes.bool,
  showDeactivated: PropTypes.bool,
};

export default VendorMultiselect;
